import { buildProtectedRoute } from '@/router/utils/buildProtectedRoute';
import { ROUTE_NAME } from '@/contexts/contractorsContext/domain/constants';
import { ROUTE_TYPE } from '@/constants';
import { hasCargoOwnerWorkplaceSubscription } from '@/domains/permissions/subscription';
import {
  canBrowseDigitalQueuesByCustomAccessRole,
  canBrowseDigitalQueuesByRole,
} from '@/domains/permissions/role/digitalQueues';

const routes = [
  buildProtectedRoute({
    path: '/digital_queues/:id?',
    name: ROUTE_NAME.digitalQueue,
    meta: {
      type: ROUTE_TYPE.private,
      permissions: [() => hasCargoOwnerWorkplaceSubscription()
        && (canBrowseDigitalQueuesByRole() || canBrowseDigitalQueuesByCustomAccessRole()),
      ],
      component: () => import('@/contexts/digitalQueuesContext/views/DigitalQueueView/index.vue'),
    },
  }),
];

export default routes;
